/**
 * @generated SignedSource<<8d71ad8429695eedb15d924730abfe27>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AddScheduleInput = {
  clientMutationId?: string | null;
  siteSlug: string;
  startTime?: string | null;
  endTime?: string | null;
};
export type ScheduleCreateFormContainer_Mutation$variables = {
  input: AddScheduleInput;
  connections: ReadonlyArray<string>;
};
export type ScheduleCreateFormContainer_MutationVariables = ScheduleCreateFormContainer_Mutation$variables;
export type ScheduleCreateFormContainer_Mutation$data = {
  readonly addSchedule: {
    readonly scheduleEdge: {
      readonly node: {
        readonly id: string;
        readonly slug: string;
        readonly startTime: string | null;
        readonly endTime: string | null;
        readonly createdAt: string | null;
        readonly updatedAt: string | null;
      } | null;
    } | null;
  } | null;
};
export type ScheduleCreateFormContainer_MutationResponse = ScheduleCreateFormContainer_Mutation$data;
export type ScheduleCreateFormContainer_Mutation = {
  variables: ScheduleCreateFormContainer_MutationVariables;
  response: ScheduleCreateFormContainer_Mutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "ScheduleEdge",
  "kind": "LinkedField",
  "name": "scheduleEdge",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Schedule",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updatedAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ScheduleCreateFormContainer_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AddSchedulePayload",
        "kind": "LinkedField",
        "name": "addSchedule",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ScheduleCreateFormContainer_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "AddSchedulePayload",
        "kind": "LinkedField",
        "name": "addSchedule",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependEdge",
            "key": "",
            "kind": "LinkedHandle",
            "name": "scheduleEdge",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "62f042679970213840d1058869d98b52",
    "id": null,
    "metadata": {},
    "name": "ScheduleCreateFormContainer_Mutation",
    "operationKind": "mutation",
    "text": "mutation ScheduleCreateFormContainer_Mutation(\n  $input: AddScheduleInput!\n) {\n  addSchedule(input: $input) {\n    scheduleEdge {\n      node {\n        id\n        slug\n        startTime\n        endTime\n        createdAt\n        updatedAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e3b7bbf4815ed26bdbfffc1e1140f0db";

export default node;
